<template>
  <div class="w-full">
    <Header v-if="layoutShow" />
    <Toast />

    <main :class="{ 'mt-[55px] lg:mt-[90px] min-h-[calc(100vh-200px)]': layoutShow }">
      <RouterView />
    </main>

    <Footer v-if="layoutShow" />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import Header from '@/components/general/Header.vue'
import Footer from '@/components/general/Footer.vue'
import Toast from '@/components/Toast.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const layoutShow = computed(() => {
  return route.name !== 'usecase-cctv'
})
</script>
